var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumbs',{staticClass:"pb-3"}),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('div',{staticClass:"elevation-1"},[_c('contracts',{attrs:{"show-link":false,"limit":15}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }